import { render, staticRenderFns } from "./mallType.vue?vue&type=template&id=beeb97c2&scoped=true"
import script from "./mallType.vue?vue&type=script&lang=js"
export * from "./mallType.vue?vue&type=script&lang=js"
import style0 from "./mallType.vue?vue&type=style&index=0&id=beeb97c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb97c2",
  null
  
)

export default component.exports